import { render, staticRenderFns } from "./NewsVerticalCard.html?vue&type=template&id=694634a0&scoped=true&external"
import script from "./NewsVerticalCard.vue?vue&type=script&lang=js"
export * from "./NewsVerticalCard.vue?vue&type=script&lang=js"
import style0 from "./NewsVerticalCard.scss?vue&type=style&index=0&id=694634a0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694634a0",
  null
  
)

export default component.exports